import { Chip } from "./Chip";
import type { NavItem } from "./NavSidebar";

export function MobileNavChips({
  items,
  activeKey,
  onSelect,
}: {
  items: NavItem[];
  activeKey?: string;
  onSelect?: (key: string) => void;
}) {
  return (
    <div className="lg:hidden relative">
      <div className="scroll-x-chips py-1 pr-6">
        {items.map((item) => (
          <div key={item.key} className="snap-start shrink-0">
            <Chip
              icon={item.icon}
              active={item.key === activeKey}
              badge={item.badge}
              badgeTone={item.badgeTone}
              onClick={() => onSelect?.(item.key)}
            >
              {item.label}
            </Chip>
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
